
import {PropType} from 'vue';
import {ChoiceFilter, Option, FilterInterface} from '../../../../src/Entity/Filter';

export default {
    props: {
        filter: {
            type: Object as PropType<ChoiceFilter>,
            required: true,
        },
        mode: {
            type: String,
            default: 'active',
        }
    },
    expose: ['support', 'change'],
    computed: {
        selectAll: {
            set: function (state: boolean) {
                this.filter.value.toggleSelectAll();
            },
            get: function (): boolean {
                return this.filter.value.isSelectAll();
            },
        }
    },
    methods: {
        support(filter: FilterInterface): boolean {
            return filter instanceof ChoiceFilter;
        },
        remove() {
            this.filter.value.reset();
        },
        onFilterOptions() {
            this.showAdditionOption = this.query !== '';
            this.options = this.filter.filter(this.query);
        },
        onChange(option: Option) {
            this.filter.value.toggle(option);
            this.$emit('change');
        },
        onChecked(option: Option): boolean {
            return !this.filter.value.isSelect(option);
        },
        onSelectOption(option: Option): void {
            this.filter.value.toggle(option);
        }
    },
    data() {
        return {
            options: this.filter.options,
            showAll: true,
            showAdditionOption: false,
            stateSelectAll: false,
            query: '',
        };
    }
};
